import { Commitment } from '@cast/types';

import { useCommitmentsQuery } from 'hooks/queries/commitments';

import { CommitmentCloudService } from '../types';

type GroupedCommitments = Record<CommitmentCloudService, Commitment[]>;

const selectGroupedCommitments = (
  commitments: Commitment[]
): GroupedCommitments => {
  return commitments.reduce<GroupedCommitments>(
    (acc, commitment) => {
      if (commitment.azureReservationContext) {
        acc.AZURE_RI.push(commitment);
      } else if (commitment.azureSavingsPlanContext) {
        acc.AZURE_SP.push(commitment);
      } else if (commitment.gcpResourceCudContext) {
        acc.GCP_RESOURCE_CUD.push(commitment);
      } else if (commitment.awsReservedInstancesContext) {
        acc.AWS_RI.push(commitment);
      } else if (commitment.awsSavingsPlanContext) {
        acc.AWS_SP.push(commitment);
      } else if (commitment.gcpFlexCudContext) {
        acc.GCP_FLEX_CUD.push(commitment);
      } else if (commitment.awsOdcrContext) {
        acc.AWS_ODCR.push(commitment);
      } else if (commitment.awsCapacityBlockContext) {
        acc.AWS_CAPACITY_BLOCK.push(commitment);
      } else if (commitment.gcpCapacityReservationContext) {
        acc.GCP_RESERVATION.push(commitment);
      }
      return acc;
    },
    {
      AZURE_RI: [],
      AZURE_SP: [],
      AWS_RI: [],
      AWS_SP: [],
      GCP_RESOURCE_CUD: [],
      GCP_FLEX_CUD: [],
      AWS_ODCR: [],
      AWS_CAPACITY_BLOCK: [],
      GCP_RESERVATION: [],
    }
  );
};

export const useGroupedCommitments = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useCommitmentsQuery({
    select: selectGroupedCommitments,
    enabled,
  });
};
